import { WebhookTranscriptUpdateSchema } from "@frontierx/types";
import { z } from "zod";
import { TranscriptQuestionClassificationSchema } from "./TranscriptQuestionClassification";

export const TranscriptUpdateSchema = WebhookTranscriptUpdateSchema.extend({
  id: z.string(),
  latency: z.number().optional(),
  end_latency: z.number().optional(),
  classification: TranscriptQuestionClassificationSchema.optional(),
});

export type TranscriptUpdate = z.infer<typeof TranscriptUpdateSchema>;
